import React from 'react'
import { FormattedMessage } from 'react-intl'
import { bodyCss } from '../../../legacy-design-system/text'
import { CodeSnippet } from '../../../legacy-design-system/code-snippet'

export function ZipFileOverwriteOverview({
  details: { entryName }
}: {
  readonly details: {
    readonly entryName: string
  }
}) {
  return (
    <div className={bodyCss}>
      <FormattedMessage
        id="detail_attackEventDetails_zipFileOverwrite_description"
        children={(msg) => <p>{msg}</p>}
      />
      <FormattedMessage
        id="detail_attackEventDetails_zipFileOverwrite_evidence"
        children={(msg) => <p>{msg}</p>}
      />
      <CodeSnippet>{entryName}</CodeSnippet>
    </div>
  )
}
